/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** DateTime scalar type - represents a point in time */
  DateTime: { input: any; output: any; }
};

/**
 * ApmPackage is one `(type, slug)` row in the tenant catalog. Search rows
 * carry the latest version and an empty version list; `getApmPackage`
 * populates the paginated version history.
 */
export type ApmPackage = {
  __typename?: 'ApmPackage';
  /** Optional package summary from the registry catalog search. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Storage path of the latest version's `.zip` within the tenant's
   * apm-local repo.
   */
  downloadPath: Scalars['String']['output'];
  /** Semver of the most recently published version. */
  latestVersion: Scalars['String']['output'];
  /** Stable package identifier within its type. */
  slug: Scalars['String']['output'];
  /** Package category. */
  type: ApmType;
  /**
   * Page of versions, newest-first. Capped at 50 per response; pass
   * `versionsNextCursor` back to `getApmPackage(type, slug, versionsAfter:)`
   * to page deeper.
   */
  versions: Array<ApmPackageVersion>;
  /** Total number of published versions for this `(type, slug)`. */
  versionsCount: Scalars['Int']['output'];
  /** Opaque cursor for the next page of versions; null when no more. */
  versionsNextCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * ApmPackageConnection is the connection shape returned by `searchApmPackages`.
 * Cursor pagination is offset-based under the hood; clients should treat
 * the cursor as opaque.
 */
export type ApmPackageConnection = {
  __typename?: 'ApmPackageConnection';
  /** Catalog rows for the current page. */
  edges: Array<ApmPackageEdge>;
  /** Pagination information for the current catalog page. */
  pageInfo: PageInfo;
  /** Total catalog rows after filters were applied (before pagination). */
  totalCount: Scalars['Int']['output'];
};

/** ApmPackageEdge wraps an APM package with its pagination cursor. */
export type ApmPackageEdge = {
  __typename?: 'ApmPackageEdge';
  /** Cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** Catalog package node. */
  node: ApmPackage;
};

/** ApmPackageOrderInput selects the catalog ordering. */
export type ApmPackageOrderInput = {
  /** Sort mode for catalog rows. */
  sort: ApmPackagesSort;
};

/**
 * ApmPackageVersion is one published version of a `(type, slug)` pair, as
 * reported by the native registry version list.
 */
export type ApmPackageVersion = {
  __typename?: 'ApmPackageVersion';
  /**
   * Registry-computed content digest (`sha256:<hex>`) of the published
   * `.zip`. Consumers verify downloads against it before unpacking.
   */
  digest: Scalars['String']['output'];
  /**
   * Storage path of this version's `.zip` within the tenant's apm-local
   * repo (`<type>/<slug>/<slug>-<version>.zip`).
   */
  downloadPath: Scalars['String']['output'];
  /** RFC3339 publish timestamp from the registry's `published_at`. */
  publishedTimestamp: Scalars['DateTime']['output'];
  /**
   * Semver string. Strict 3-segment form (MAJOR.MINOR.PATCH); pre-release
   * and build metadata segments are allowed.
   */
  version: Scalars['String']['output'];
};

/** ApmPackageWhereInput filters the team package catalog. */
export type ApmPackageWhereInput = {
  /** Free-text search forwarded to the registry catalog search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict results to one package category. */
  type?: InputMaybe<ApmType>;
};

/** ApmPackagesSort selects the ordering for `searchApmPackages` results. */
export enum ApmPackagesSort {
  /** Newest published version first (by latest semver). */
  LatestPublishedDesc = 'LATEST_PUBLISHED_DESC',
  /** Package slug ascending. */
  SlugAsc = 'SLUG_ASC',
  /** Package slug descending. */
  SlugDesc = 'SLUG_DESC'
}

/**
 * ApmType enumerates the installable team APM types per
 * `docs/prds/skills-sharing-apm.md`.
 */
export enum ApmType {
  /**
   * Instructions package: one or more `*.instructions.md` cross-harness
   * instruction files (deploys to `.cursor/rules/`, `.claude/rules/`,
   * `.github/instructions/`). Users often say "rules" — same type.
   */
  Instructions = 'INSTRUCTIONS',
  /** Cursor/Claude-style skill package. */
  Skill = 'SKILL'
}

/** Artifact represents a package/artifact in the registry */
export type Artifact = {
  __typename?: 'Artifact';
  /** URL-encoded artifact name */
  encodedName: Scalars['String']['output'];
  /**
   * True when at least one version of this artifact is currently publicly distributed.
   * Drives the "Public" badge on the All Artifacts page.
   *
   * Supports Generic (Phase 1) and Docker (Phase 2). Returns false for artifact
   * types that aren't yet wired into public distribution (npm, pypi, maven, ...).
   * Future phases will keep extending this same field — the name is type-agnostic
   * on purpose so the FE never has to relearn the concept.
   *
   * Computed via one AQL scan per supported type that the page actually contains:
   * `-generic-public` for Generic artifacts, `-docker-public` for Docker. Each
   * scan is capped at PublicGenericArtifactsLimit rows; tenants whose total file
   * count exceeds the cap may see false negatives for the truncated-tail entries.
   * Saturation is logged server-side so operators can detect it.
   */
  hasPublicDistributedArtifact?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of the most recent version upload */
  lastUploadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The most recently uploaded version */
  latestVersion: ArtifactVersion;
  /** Name of the artifact (package name) */
  name: Scalars['String']['output'];
  /** Package type (e.g., npm, docker, maven, pypi) */
  packageType: Scalars['String']['output'];
  /** Git repository associated with this artifact (if known) */
  repository?: Maybe<ArtifactRepository>;
  /** Paginated list of all versions. Use where.search to filter by version name (case-insensitive substring). */
  versions: ArtifactVersionConnection;
  /** Count of versions for this artifact */
  versionsCount: Scalars['Int']['output'];
};


/** Artifact represents a package/artifact in the registry */
export type ArtifactVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArtifactVersionWhereInput>;
};

/**
 * ArtifactConnection is a paginated list of artifacts.
 * Note: totalCount is nullable (Int) by design for cursor-only pagination (e.g. searchArtifacts);
 * callers must handle null.
 */
export type ArtifactConnection = {
  __typename?: 'ArtifactConnection';
  /** List of artifact edges */
  edges: Array<ArtifactEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of artifacts matching the query (null when using cursor-only pagination, e.g. searchArtifacts). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** ArtifactEdge wraps an Artifact with its pagination cursor */
export type ArtifactEdge = {
  __typename?: 'ArtifactEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The artifact node */
  node: Artifact;
};

/** Input for querying a specific artifact */
export type ArtifactInput = {
  /** Name of the artifact (required) */
  name: Scalars['String']['input'];
  /** Package type of the artifact (required) */
  packageType: Scalars['String']['input'];
};

/** ArtifactRepository represents the Git repository associated with an artifact */
export type ArtifactRepository = {
  __typename?: 'ArtifactRepository';
  /** URL-encoded repository name */
  encodedName: Scalars['String']['output'];
  /** URL-encoded owner name */
  encodedOwner: Scalars['String']['output'];
  /** Name of the repository */
  name: Scalars['String']['output'];
  /** Owner of the repository */
  owner: Scalars['String']['output'];
};

/** ArtifactVersion represents a specific version of an artifact */
export type ArtifactVersion = {
  __typename?: 'ArtifactVersion';
  /**
   * Aggregate distribution info for this version.
   * Null when the version is not publicly distributed.
   */
  distribution?: Maybe<DistributionSummary>;
  /** URL-encoded version name */
  encodedName: Scalars['String']['output'];
  /** Whether this is a first-party artifact (published by your team) */
  firstParty: Scalars['Boolean']['output'];
  /**
   * True when this artifact version is currently publicly distributed
   * (at least one file row has is_public = true). Redundant with `distribution != null`
   * but kept as an explicit flag for FE convenience.
   */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when this version was uploaded */
  lastUploadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Version name/number */
  name: Scalars['String']['output'];
  /** Paginated list of releases that produced this version */
  releases: ReleaseConnection;
  /**
   * For Docker, OCI, and Helm OCI only: when multiple registry tags reference the same
   * manifest (same manifest blob identity), this row is the representative tag and
   * `tags` lists every other co-tag name sorted by create time (OneModel createdAt) ascending. Empty when there are no aliases.
   * Non-OCI package types always return an empty list.
   * Under artifact version search, co-tags are best-effort: the server indexes at most
   * 150 versions (3 × 50) per artifact when resolving manifest siblings; artifacts with
   * more versions may omit co-tags for tags outside that window.
   */
  tags: Array<Scalars['String']['output']>;
  /** User who uploaded this version */
  uploadedBy: Scalars['String']['output'];
  /** Whether this version was uploaded locally (not via CI) */
  uploadedLocally: Scalars['Boolean']['output'];
  /**
   * Download URL for this version. Always set when the tenant base URL can be
   * resolved (set to null only in local dev / missing tenant info).
   *
   * The route depends on both isPublic and packageType — the FE consumes this
   * single field without needing to know route conventions:
   *
   * Generic:
   *   - Public (isPublic == true): https://{tenant}.{domain}/public/generic/{name}/{version}
   *   - Private:                   https://{tenant}.{domain}/fly/api/v1/generic/{name}/{version}/
   *
   * Docker:
   *   - Public:  the canonical `docker pull` command —
   *              `docker pull {tenant}.{domain}/docker-public/{image}:{tag}`
   *              (returned as a `docker pull ...` string rather than an https URL
   *              because Docker clients consume `docker pull`, not HTTPS GET).
   *              The `docker-public/` prefix IS the routing signal: requests
   *              to that namespace skip auth and are served read-only from the
   *              tenant's `{accountId}-docker-public` Artifactory repo.
   *   - Private: `docker pull {tenant}.{domain}/{image}:{tag}` (uses the
   *              authenticated registry; no `docker-public/` prefix).
   *
   * When isPublic is null (distribution status unknown due to a transient load
   * failure), this field is also null so the FE can avoid rendering a stale link.
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated: Use releases instead. Kept for backward compatibility with flyman.
   * TODO: Remove once flyman migrates to Release types.
   * @deprecated Use releases instead
   */
  workflowRuns: WorkflowRunConnection;
};


/** ArtifactVersion represents a specific version of an artifact */
export type ArtifactVersionReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** ArtifactVersion represents a specific version of an artifact */
export type ArtifactVersionWorkflowRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** ArtifactVersionConnection is a paginated list of artifact versions */
export type ArtifactVersionConnection = {
  __typename?: 'ArtifactVersionConnection';
  /** List of version edges */
  edges: Array<ArtifactVersionEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of versions */
  totalCount: Scalars['Int']['output'];
};

/** ArtifactVersionEdge wraps an ArtifactVersion with its pagination cursor */
export type ArtifactVersionEdge = {
  __typename?: 'ArtifactVersionEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The artifact version node */
  node: ArtifactVersion;
};

/** Filter for artifact versions connection (Relay connection: where only). */
export type ArtifactVersionWhereInput = {
  /** Filter by version name (case-insensitive substring match). */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for searching artifacts. */
export type ArtifactWhereInput = {
  /** Filter by first-party artifacts only (defaults to true) */
  firstParty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional artifact name pattern (explicit; use search for free-text). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of artifact names; when set, only artifacts whose name is in this list are returned. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional list of package types; artifacts matching any of these types are returned. */
  packageTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional repository name filter */
  repositoryName?: InputMaybe<Scalars['String']['input']>;
  /** Optional repository owner filter */
  repositoryOwner?: InputMaybe<Scalars['String']['input']>;
  /** Free-text search: matches artifact name (contains, case-sensitive). Maps to nameContains in backend. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter to artifacts with lastUploadTimestamp at or after this time (inclusive) */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter to artifacts with lastUploadTimestamp at or before this time (inclusive) */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Commit represents a Git commit */
export type Commit = {
  __typename?: 'Commit';
  /** GitHub login of the commit author */
  author?: Maybe<Scalars['String']['output']>;
  /** Full body of the commit message (excluding first line) */
  body: Scalars['String']['output'];
  /** First line of the commit message */
  message: Scalars['String']['output'];
  /** SHA hash of the commit */
  sha: Scalars['String']['output'];
  /** Timestamp when the commit was created */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  /** URL to the commit on the VCS provider */
  url: Scalars['String']['output'];
};

/** CommitConnection is a paginated list of commits */
export type CommitConnection = {
  __typename?: 'CommitConnection';
  /** List of commit edges */
  edges: Array<CommitEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of commits */
  totalCount: Scalars['Int']['output'];
};

/** CommitEdge wraps a Commit with its pagination cursor */
export type CommitEdge = {
  __typename?: 'CommitEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The commit node */
  node: Commit;
};

/**
 * DecisionRecord is an architectural or implementation decision extracted from
 * developer-agent conversations linked to a release.
 */
export type DecisionRecord = {
  __typename?: 'DecisionRecord';
  /**
   * GitHub login of the developer credited with this decision, resolved from
   * the release's commit authors. Null when no author could be attributed.
   */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the decision record was extracted. */
  createdTime: Scalars['DateTime']['output'];
  /** Decision rationale and context. */
  description: Scalars['String']['output'];
  /** Unique identifier for the decision record. */
  id: Scalars['ID']['output'];
  /** Decision category, such as architecture, constraint, feature, or bugfix. */
  recordType: Scalars['String']['output'];
  /**
   * Database IDs of the releases that reference this decision record. Lets the
   * Decision Records page link a DR back to its originating release(s).
   */
  releaseIds: Array<Scalars['ID']['output']>;
  /**
   * Repositories this decision applies to ("owner/name" form). Used by the
   * standalone Decision Records page for repository chips / client-side grouping.
   * Always populated by the resolver; returned only when selected (standard
   * GraphQL field selection), so the nested Release.decisionRecords path can omit
   * it without cost.
   */
  repositories: Array<Scalars['String']['output']>;
  /** Human-readable decision title. */
  title: Scalars['String']['output'];
};

/** DecisionRecordConnection is a paginated list of decision records. */
export type DecisionRecordConnection = {
  __typename?: 'DecisionRecordConnection';
  /** Decision record edges for the current page. */
  edges: Array<DecisionRecordEdge>;
  /** Pagination information for the current page. */
  pageInfo: PageInfo;
};

/** DecisionRecordEdge wraps a DecisionRecord with its pagination cursor. */
export type DecisionRecordEdge = {
  __typename?: 'DecisionRecordEdge';
  /** Cursor for this edge, used for pagination. */
  cursor: Scalars['String']['output'];
  /** The decision record node. */
  node: DecisionRecord;
};

/**
 * DecisionRecordRepositoryCount is one repository section header on the grouped
 * Decision Records page: the repository and how many active DRs it has.
 */
export type DecisionRecordRepositoryCount = {
  __typename?: 'DecisionRecordRepositoryCount';
  /** Number of active decision records that apply to this repository. */
  count: Scalars['Int']['output'];
  /** Repository in "owner/name" form. */
  repository: Scalars['String']['output'];
};

/**
 * Filter input for getDecisionRecords / searchDecisionRecordRepositories. All
 * fields optional; combined with AND, while values within each list use OR.
 * Intentionally extensible — record-type filters are additive future fields.
 */
export type DecisionRecordWhereInput = {
  /**
   * Match records whose repos contain ANY of these repositories (OR). Compared
   * case-insensitively server-side (the source repos are lowercased on write).
   */
  repositories?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Free-text term matched case-insensitively against linked repository names
   * ("owner/name" substring). Trimmed; empty/whitespace is ignored. Omit on
   * repo-scoped pages that should match title/description only. When both
   * `search` and `repositoryNameSearch` are set, a record matches if either
   * predicate matches (OR).
   */
  repositoryNameSearch?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-text term matched case-insensitively against the decision record's
   * title and description only. Trimmed; empty/whitespace is ignored. When both
   * `search` and `repositoryNameSearch` are set, a record matches if either
   * predicate matches (OR).
   */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Deploy type classifies the nature of a deployment wave. */
export enum DeployType {
  /** First-ever deployment to this environment for this workflow */
  FirstDeploy = 'FIRST_DEPLOY',
  /** Multiple releases landed in one wave (skipped intermediate releases) */
  MultiRelease = 'MULTI_RELEASE',
  /** Rolling back to a previous release version */
  Rollback = 'ROLLBACK',
  /** Single release deployed on a normal cadence */
  Routine = 'ROUTINE'
}

/**
 * DeploymentDelta represents the difference between consecutive deployments of the same
 * workflow to an environment. Contains intermediate releases that were created but never
 * deployed, and an optional AI-generated cumulative summary.
 */
export type DeploymentDelta = {
  __typename?: 'DeploymentDelta';
  /**
   * AI-generated cumulative short summary (≤200 characters, verb-led format).
   * Null when the summary hasn't been generated yet — clients MUST render a loading/skeleton
   * state and MUST NOT fall back to currentDeployment.shortSummary (see cumulativeSummary).
   */
  cumulativeShortSummary?: Maybe<Scalars['String']['output']>;
  /**
   * AI-generated cumulative summary covering all changes from previous to current deployment.
   * Null when the summary hasn't been generated yet — clients MUST render a loading/skeleton
   * state and MUST NOT fall back to currentDeployment.summary. Falling back surfaced misleading
   * release-level text for multi-release and rollback waves (jfrog/fly-service#1447); the
   * cumulative fields are the single source of truth, shown only once Flyman has generated them.
   */
  cumulativeSummary?: Maybe<Scalars['String']['output']>;
  /**
   * AI-generated cumulative title.
   * Null when the summary hasn't been generated yet — clients MUST render a loading/skeleton
   * state and MUST NOT fall back to currentDeployment.title (see cumulativeSummary).
   */
  cumulativeTitle?: Maybe<Scalars['String']['output']>;
  /** The latest (current) deployment to this environment */
  currentDeployment: EnvironmentRelease;
  /** Days since the previous deployment (null for first deploy) */
  daysSinceLastDeploy?: Maybe<Scalars['Int']['output']>;
  /** Deploy type: routine, multi_release, rollback, or first_deploy */
  deployType: DeployType;
  /**
   * Opaque, stable identifier for this deployment wave. Encodes the
   * (environmentName, workflowName, workflowNumber) triple in a URL-safe
   * base64 envelope so the FE can route the wave through query params /
   * deep links without worrying about reserved characters in workflow names
   * (e.g. "Build & Publish"). Decode is server-side; the resolved environment
   * is always validated against the caller's tenant context (tenant scoping
   * happens in the resolver via `environmentService.Get(ctx, tenantID, name)`,
   * not in the decoder itself). Clients MUST treat this as opaque. Pass it
   * back via ReleaseWhereInput.deploymentId to scope the Releases page to
   * this wave.
   */
  id: Scalars['ID']['output'];
  /**
   * Releases created between the previous and current deployment that were never
   * individually deployed to this environment. Ordered by started_at ASC.
   * When `limit` is set to a positive value, returns at most that many entries from
   * the end of the list (the most recent intermediates). Omit or null for the full list.
   */
  intermediateReleases: Array<IntermediateRelease>;
  /**
   * True when this deployment wave is the most recent pull on the environment
   * (global max pulled_at), regardless of search pagination. Used for the
   * \"Recent\" badge on the Deployments tab.
   */
  isLatestOnEnvironment: Scalars['Boolean']['output'];
  /** The deployment before the current one (null for first-ever deployment) */
  previousDeployment?: Maybe<EnvironmentRelease>;
  /** Number of releases in this deployment wave (current + intermediates) */
  releaseCount: Scalars['Int']['output'];
  /** Repository name */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** Repository owner (GitHub org or user) */
  repositoryOwner?: Maybe<Scalars['String']['output']>;
  /**
   * Total number of commits across the current deployment and any intermediate
   * releases skipped between previousDeployment and currentDeployment. For a
   * single-release deploy this equals the current release's commit count.
   */
  totalCommitCount: Scalars['Int']['output'];
  /**
   * Total number of pull requests across the current deployment and any
   * intermediate releases skipped between previousDeployment and
   * currentDeployment. For a single-release deploy this equals the current
   * release's pull request count.
   */
  totalPullRequestCount: Scalars['Int']['output'];
  /** Workflow name (CI workflow that produces releases) */
  workflowName: Scalars['String']['output'];
};


/**
 * DeploymentDelta represents the difference between consecutive deployments of the same
 * workflow to an environment. Contains intermediate releases that were created but never
 * deployed, and an optional AI-generated cumulative summary.
 */
export type DeploymentDeltaIntermediateReleasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * DeploymentDeltaConnection is a paginated list of historical deployment waves
 * on one environment, most-recent first. One node = one DeploymentDelta — same
 * shape as Environment.deploymentDeltas, including cumulative summaries,
 * rollback classification, and the wave's intermediate releases (rollback-aware
 * per fly-service#1122 §2.3).
 */
export type DeploymentDeltaConnection = {
  __typename?: 'DeploymentDeltaConnection';
  /** List of deployment-delta edges containing the nodes and cursors. */
  edges: Array<DeploymentDeltaEdge>;
  /** Pagination information. */
  pageInfo: PageInfo;
};

/** DeploymentDeltaEdge wraps a DeploymentDelta with its pagination cursor. */
export type DeploymentDeltaEdge = {
  __typename?: 'DeploymentDeltaEdge';
  /** Cursor for this edge, used for pagination. */
  cursor: Scalars['String']['output'];
  /** The deployment-delta node (one historical wave). */
  node: DeploymentDelta;
};

/**
 * Reference to a single deployment wave on a specific environment.
 * A wave is uniquely identified by (environmentName, workflowName, workflowNumber):
 * the workflow run number that landed on the env. Used by getReleases.deployment
 * to scope the result to that wave's release set (current + rollback-aware
 * intermediates) per fly-service#1122 §2.3.
 */
export type DeploymentRefInput = {
  /**
   * Environment name — exact, case-sensitive match against Environment.name.
   * Pass the value directly from the deployment card / Environment.name; do not
   * normalize casing client-side. (Note: this is intentionally stricter than
   * ReleaseWhereInput.environmentNames, which lowercases for compatibility with
   * legacy callers; we want the deployment filter to agree byte-for-byte with
   * the wave-lookup CTE used by the env page.)
   */
  environmentName: Scalars['String']['input'];
  /**
   * Workflow name (exact match) — same value as EnvironmentRelease.name on the
   * deployment card.
   */
  workflowName: Scalars['String']['input'];
  /**
   * Workflow run number (exact match) — same value as EnvironmentRelease.number
   * on the deployment card.
   */
  workflowNumber: Scalars['String']['input'];
};

/**
 * DistributedFile represents a single file within an artifact version,
 * regardless of whether it has been publicly distributed.
 * The download URL is returned in the `url` field — the client never constructs it.
 */
export type DistributedFile = {
  __typename?: 'DistributedFile';
  /** Who made this version public. Null for private files. */
  distributedBy?: Maybe<Scalars['String']['output']>;
  /** When this version was made public. Null for private files. */
  distributedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Number of downloads for this specific file. Zero for private files. */
  downloadCount: Scalars['Int']['output'];
  /** Filename of the distributed file. */
  fileName: Scalars['String']['output'];
  /** Whether this file has been publicly distributed. */
  isPublic: Scalars['Boolean']['output'];
  /** Package name (artifact name) this file belongs to. */
  packageName: Scalars['String']['output'];
  /** Package version this file belongs to. */
  packageVersion: Scalars['String']['output'];
  /** SHA256 checksum of the file. */
  sha256?: Maybe<Scalars['String']['output']>;
  /**
   * Download URL for this file. Set for Generic files when the tenant base URL
   * can be resolved (null in local dev / missing tenant info). For Docker, the
   * URL is null at the file level — Docker clients pull a tag, not individual
   * blobs; the pull command lives on ArtifactVersion.url instead.
   *
   * Generic route depends on isPublic — the FE consumes this single field
   * without needing to know route conventions:
   *
   * - Publicly distributed files (isPublic == true): unauthenticated CDN-fronted URL.
   *   Format: https://{tenant}.{env-domain}/public/generic/{name}/{version}/{file}
   *
   * - Non-public files (isPublic == false): authenticated Fly download URL,
   *   requires the caller's session/PAT.
   *   Format: https://{tenant}.{env-domain}/fly/api/v1/generic/{name}/{version}/{file}
   */
  url?: Maybe<Scalars['String']['output']>;
};

/** DistributedFileConnection is a paginated list of distributed files. */
export type DistributedFileConnection = {
  __typename?: 'DistributedFileConnection';
  /** List of distributed file edges */
  edges: Array<DistributedFileEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of distributed files */
  totalCount: Scalars['Int']['output'];
};

/** DistributedFileEdge wraps a DistributedFile with its pagination cursor. */
export type DistributedFileEdge = {
  __typename?: 'DistributedFileEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The distributed file node */
  node: DistributedFile;
};

/** Filter input for searching distributed files of a specific artifact version. */
export type DistributedFileWhereInput = {
  /** Package name (artifact name). */
  packageName: Scalars['String']['input'];
  /**
   * Package type — drives how file existence is enumerated and which
   * Artifactory `-local` repo is scanned (defaults to "generic" when omitted
   * for backward compatibility with the original Generic-only contract).
   * Currently supported: "generic", "docker".
   */
  packageType?: InputMaybe<Scalars['String']['input']>;
  /** Package version. */
  packageVersion: Scalars['String']['input'];
};

/**
 * DistributionSummary provides aggregate distribution info for an artifact version.
 * Used by the artifact-version list; individual files are fetched via distributedFiles.
 */
export type DistributionSummary = {
  __typename?: 'DistributionSummary';
  /** Who made this version public. */
  distributedBy?: Maybe<Scalars['String']['output']>;
  /** When this version was made public. */
  distributedTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Public download/pull URL for this distributed version. Generic artifacts get
   * the unauthenticated CDN URL; Docker artifacts get the canonical
   * `docker pull {tenant}.{domain}/docker-public/{image}:{tag}` command.
   * Null when the tenant base URL cannot be resolved (local dev / missing tenant info).
   */
  distributionUrl?: Maybe<Scalars['String']['output']>;
  /** Total download count across all distributed files for this version. */
  downloadCount: Scalars['Int']['output'];
};

/** Environment represents a runtime environment (e.g., production, staging, dev) */
export type Environment = {
  __typename?: 'Environment';
  /** Hex color for UI display (e.g., #FF5733) */
  color?: Maybe<Scalars['String']['output']>;
  /**
   * Total number of distinct deployment waves on this environment, across all
   * workflows, over time. Each wave = one release pulled to the env (regardless
   * of how many images that release produced). Drives the "# Deployments" footer
   * badge on the env card per fly-service#1122 §3 (replaces "# Releases").
   */
  deploymentCount: Scalars['Int']['output'];
  /**
   * Deployment deltas for this environment, grouped by workflow and ordered
   * by current deployment's `lastPulled` descending — most recent first, so
   * consumers can rely on `deploymentDeltas[0]` as the env's latest deploy
   * (matches `searchEnvironmentDeployments` ordering).
   * Each delta shows the current and previous deployment plus any intermediate
   * releases that were created but never deployed. Includes AI-generated
   * cumulative summaries when available.
   */
  deploymentDeltas: Array<DeploymentDelta>;
  /** Optional description of the environment */
  description?: Maybe<Scalars['String']['output']>;
  /** Internal database identifier */
  id: Scalars['ID']['output'];
  /** The most recent release deployed to this environment (for dashboard cards) */
  latestRelease?: Maybe<EnvironmentRelease>;
  /** The name of the environment (unique per tenant, used in URLs) */
  name: Scalars['String']['output'];
  /** Total number of unique releases deployed to this environment */
  releaseCount: Scalars['Int']['output'];
  /**
   * Releases deployed to this environment.
   * Use the where input to filter by workflow name and/or run number.
   */
  releases: Array<EnvironmentRelease>;
  /** Display order position (0-based). Lower values appear first. */
  sortOrder: Scalars['Int']['output'];
  /** Total number of access tokens associated with this environment */
  tokenCount: Scalars['Int']['output'];
};


/** Environment represents a runtime environment (e.g., production, staging, dev) */
export type EnvironmentReleasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EnvironmentReleaseWhereInput>;
};

/** EnvironmentConnection is a paginated list of environments */
export type EnvironmentConnection = {
  __typename?: 'EnvironmentConnection';
  /** List of environment edges containing the nodes and cursors */
  edges: Array<EnvironmentEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of environments matching the query */
  totalCount: Scalars['Int']['output'];
};

/** EnvironmentEdge wraps an Environment with its pagination cursor */
export type EnvironmentEdge = {
  __typename?: 'EnvironmentEdge';
  /** Cursor for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The environment node */
  node: Environment;
};

/** EnvironmentImage represents a Docker image pulled to an environment */
export type EnvironmentImage = {
  __typename?: 'EnvironmentImage';
  /** Image name (e.g., fly-service:2026.01.14-09.43.42) */
  name: Scalars['String']['output'];
  /** When the image was pulled */
  pulled: Scalars['DateTime']['output'];
};

/** Sort field for environment list (name or updated_at). */
export enum EnvironmentOrderByField {
  /** Sort by environment name */
  Name = 'NAME',
  /** Sort by last updated timestamp */
  UpdatedAt = 'UPDATED_AT'
}

/** Ordering for environment list. Default when omitted: sort_order ASC (custom drag-and-drop order). */
export type EnvironmentOrderInput = {
  /** Sort direction. */
  direction: EnvironmentSortDirection;
  /** Field to sort by (name or updated_at). */
  field: EnvironmentOrderByField;
};

/** EnvironmentRelease represents a workflow run (release) deployed to an environment */
export type EnvironmentRelease = {
  __typename?: 'EnvironmentRelease';
  /** Number of commits included in this release */
  commitCount: Scalars['Int']['output'];
  /** The environment name this release belongs to */
  environmentName: Scalars['String']['output'];
  /** Number of unique images pulled as part of this release */
  imageCount: Scalars['Int']['output'];
  /** Images pulled as part of this release */
  images: Array<EnvironmentImage>;
  /**
   * Whether this deployment was from a local push (not via CI).
   * When true, name will be "Local" and fields like summary, url, repositoryOwner, repositoryName will be null.
   */
  isLocal: Scalars['Boolean']['output'];
  /** When the most recent image in this release was pulled */
  lastPulled: Scalars['DateTime']['output'];
  /** Workflow name (from releases table) */
  name: Scalars['String']['output'];
  /** Workflow run number (from releases table) */
  number: Scalars['String']['output'];
  /** Number of pull requests included in this release */
  pullRequestCount: Scalars['Int']['output'];
  /** Repository name from the release's VCS repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** Repository owner (GitHub org or user) from the release's VCS repository */
  repositoryOwner?: Maybe<Scalars['String']['output']>;
  /** Short summary for dashboard display from the releases table */
  shortSummary?: Maybe<Scalars['String']['output']>;
  /** Full release summary from the releases table */
  summary?: Maybe<Scalars['String']['output']>;
  /** AI-generated release title with emoji categorization from the releases table */
  title?: Maybe<Scalars['String']['output']>;
  /** User who triggered the workflow run that produced this release */
  uploadedBy?: Maybe<Scalars['String']['output']>;
  /** URL to the CI workflow run that produced this release (e.g., GitHub Actions run URL) */
  url?: Maybe<Scalars['String']['output']>;
};

/** EnvironmentReleaseConnection is a paginated list of environment releases */
export type EnvironmentReleaseConnection = {
  __typename?: 'EnvironmentReleaseConnection';
  /** List of environment release edges containing the nodes and cursors */
  edges: Array<EnvironmentReleaseEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** EnvironmentReleaseEdge wraps an EnvironmentRelease with its pagination cursor */
export type EnvironmentReleaseEdge = {
  __typename?: 'EnvironmentReleaseEdge';
  /** Cursor for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The environment release node */
  node: EnvironmentRelease;
};

/**
 * Filter input for environment releases.
 * All fields are optional; when multiple are provided they are combined with AND logic.
 */
export type EnvironmentReleaseWhereInput = {
  /** Filter by workflow name (exact match). Returns only releases from this workflow. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by workflow run number (exact match). Returns only the release with this run number.
   * Typically used together with name to identify a specific release.
   */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Filter releases pulled after this timestamp (inclusive). */
  pulledAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter releases pulled before this timestamp (inclusive). */
  pulledBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Sort direction for environment list. */
export enum EnvironmentSortDirection {
  /** Ascending order */
  Asc = 'ASC',
  /** Descending order */
  Desc = 'DESC'
}

/**
 * Filter for environment list queries (Relay connection args: first, last, before, after, orderBy, where only).
 * When both names and search are provided, results must match both (name in list and name contains search).
 */
export type EnvironmentWhereInput = {
  /** Optional list of environment names (exact match). When provided and non-empty, returns only environments whose name is in this list (e.g. stage, prod). Use one or many names. Omit or pass empty for no name filter. */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional free-text search on environment name (case-insensitive substring match). When provided and non-empty, returns only environments whose name contains this string. When used together with names, results match both filters. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * FlyApmQueries groups every catalog read query, matching the existing
 * `FlyArtifactsQueries` / `FlyReleasesQueries` shape.
 */
export type FlyApmQueries = {
  __typename?: 'FlyApmQueries';
  /**
   * Single-package fetch with paginated version history, backed by the
   * registry version list.
   */
  getApmPackage?: Maybe<ApmPackage>;
  /** Catalog browse + filter, backed by the registry catalog search. */
  searchApmPackages: ApmPackageConnection;
};


/**
 * FlyApmQueries groups every catalog read query, matching the existing
 * `FlyArtifactsQueries` / `FlyReleasesQueries` shape.
 */
export type FlyApmQueriesGetApmPackageArgs = {
  slug: Scalars['String']['input'];
  type: ApmType;
  versionsAfter?: InputMaybe<Scalars['String']['input']>;
};


/**
 * FlyApmQueries groups every catalog read query, matching the existing
 * `FlyArtifactsQueries` / `FlyReleasesQueries` shape.
 */
export type FlyApmQueriesSearchApmPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApmPackageOrderInput>;
  where?: InputMaybe<ApmPackageWhereInput>;
};

/** Queries for artifacts */
export type FlyArtifactsQueries = {
  __typename?: 'FlyArtifactsQueries';
  /** Get a specific artifact by package type and name */
  getArtifact?: Maybe<Artifact>;
  /** Search for artifacts with optional filters and pagination */
  searchArtifacts: ArtifactConnection;
  /** List individual files for a publicly distributed artifact version, with pagination. */
  searchDistributedFiles: DistributedFileConnection;
  /** Search publicly distributed artifact versions for the current tenant, ordered by distributedTime DESC */
  searchPublicArtifacts: ArtifactVersionConnection;
};


/** Queries for artifacts */
export type FlyArtifactsQueriesGetArtifactArgs = {
  input: ArtifactInput;
};


/** Queries for artifacts */
export type FlyArtifactsQueriesSearchArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArtifactWhereInput>;
};


/** Queries for artifacts */
export type FlyArtifactsQueriesSearchDistributedFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where: DistributedFileWhereInput;
};


/** Queries for artifacts */
export type FlyArtifactsQueriesSearchPublicArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Queries for decision records as a first-class, tenant-wide entity.
 *
 * Unlike Release.decisionRecords (which lists the DRs of a single release), this
 * namespace exposes ALL of a tenant's active decision records — paginated and
 * groupable by repository — for the dedicated Decision Records page.
 */
export type FlyDecisionRecordsQueries = {
  __typename?: 'FlyDecisionRecordsQueries';
  /**
   * Paginated active decision records for the authenticated tenant, ordered
   * created_at DESC, id DESC. Offset-based stringified-int cursors (consistent
   * with getReleases). Omitting `where` returns all active DRs for the tenant.
   * `first` defaults to 50 when omitted and is silently capped at 100 per page.
   * Use `pageInfo.hasNextPage` for infinite scroll; aggregate counts live on
   * `searchDecisionRecordRepositories`.
   */
  getDecisionRecords?: Maybe<DecisionRecordConnection>;
  /**
   * Repositories that have at least one active decision record matching `where`,
   * with per-repo counts — the expandable section headers for the grouped
   * Decision Records page. A DR that applies to multiple repos is counted under
   * each. When any search field is set the counts reflect only matching records
   * and repos with zero matches drop out. To keep header counts aligned with the
   * rows shown when a section expands, pass the same `where` (search fields and
   * all) to both this query and `getDecisionRecords`. Ordered by count DESC, then
   * repository ASC.
   */
  searchDecisionRecordRepositories: Array<DecisionRecordRepositoryCount>;
};


/**
 * Queries for decision records as a first-class, tenant-wide entity.
 *
 * Unlike Release.decisionRecords (which lists the DRs of a single release), this
 * namespace exposes ALL of a tenant's active decision records — paginated and
 * groupable by repository — for the dedicated Decision Records page.
 */
export type FlyDecisionRecordsQueriesGetDecisionRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DecisionRecordWhereInput>;
};


/**
 * Queries for decision records as a first-class, tenant-wide entity.
 *
 * Unlike Release.decisionRecords (which lists the DRs of a single release), this
 * namespace exposes ALL of a tenant's active decision records — paginated and
 * groupable by repository — for the dedicated Decision Records page.
 */
export type FlyDecisionRecordsQueriesSearchDecisionRecordRepositoriesArgs = {
  where?: InputMaybe<DecisionRecordWhereInput>;
};

/** Queries for environments in the Fly registry */
export type FlyEnvironmentsQueries = {
  __typename?: 'FlyEnvironmentsQueries';
  /**
   * Paginated historical deployment waves for one environment, ordered by deploy
   * time (pulled_at) descending. One node per wave (= one release pulled to the
   * env). Each DeploymentDelta is fully populated, including cumulative AI
   * summaries when available, the rollback flag, and the wave's intermediate
   * releases (rollback-aware per fly-service#1122 §2.3). Uses the same
   * offset-style virtual-scroll cursor semantics as searchEnvironmentReleases.
   */
  searchEnvironmentDeployments: DeploymentDeltaConnection;
  /**
   * Paginated releases for one environment, ordered by most recent pull time descending.
   * Uses the same offset-style virtual-scroll cursor semantics as getReleases.
   */
  searchEnvironmentReleases: EnvironmentReleaseConnection;
  /** Search environments. Use where.names for exact match by one or more names (e.g. stage, prod), where.search for free-text name search, or both to filter on both. Omit where for all. orderBy defaults to sort_order ASC (custom drag-and-drop order). */
  searchEnvironments: EnvironmentConnection;
};


/** Queries for environments in the Fly registry */
export type FlyEnvironmentsQueriesSearchEnvironmentDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where: FlyEnvironmentsQueriesToDeploymentDeltaWhereInput;
};


/** Queries for environments in the Fly registry */
export type FlyEnvironmentsQueriesSearchEnvironmentReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where: FlyEnvironmentsQueriesToEnvironmentReleaseWhereInput;
};


/** Queries for environments in the Fly registry */
export type FlyEnvironmentsQueriesSearchEnvironmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnvironmentOrderInput>;
  where?: InputMaybe<EnvironmentWhereInput>;
};

/**
 * Filter input for the per-environment paginated deployments connection.
 * Used by searchEnvironmentDeployments to scope the historical wave list to one
 * env. Mirrors FlyEnvironmentsQueriesToEnvironmentReleaseWhereInput shape so the
 * two paginated queries on the env page have matching ergonomics.
 */
export type FlyEnvironmentsQueriesToDeploymentDeltaWhereInput = {
  /** Required environment name (exact match). Returns deployment waves only for this env. */
  environmentName: Scalars['String']['input'];
  /**
   * Optional free-text search (case-insensitive substring) matched against the
   * deployment release's title, short summary, and full summary.
   */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Filter input for the top-level paginated environment releases connection. */
export type FlyEnvironmentsQueriesToEnvironmentReleaseWhereInput = {
  /** Required environment name (exact match). Returns releases only for this environment. */
  environmentName: Scalars['String']['input'];
  /** Optional free-text search on release title (case-insensitive substring match). */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Queries for Git repositories */
export type FlyGitRepositoriesQueries = {
  __typename?: 'FlyGitRepositoriesQueries';
  /** Get a specific repository by owner and name */
  getRepository?: Maybe<Repository>;
  /** Search for repositories with optional filters and pagination */
  searchRepositories: RepositoryConnection;
};


/** Queries for Git repositories */
export type FlyGitRepositoriesQueriesGetRepositoryArgs = {
  input: RepositoryInput;
};


/** Queries for Git repositories */
export type FlyGitRepositoriesQueriesSearchRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RepositoryWhereInput>;
};

/** Queries for registry insights */
export type FlyOperationalInfoQueries = {
  __typename?: 'FlyOperationalInfoQueries';
  /** Get registry insights and statistics */
  getRegistryInsights?: Maybe<RegistryInsights>;
};


/** Queries for registry insights */
export type FlyOperationalInfoQueriesGetRegistryInsightsArgs = {
  input?: InputMaybe<RegistryInsightsInput>;
};

/** Queries for releases */
export type FlyReleasesQueries = {
  __typename?: 'FlyReleasesQueries';
  /**
   * Get a specific release by its database UUID.
   * Returns null for invalid, non-existent, or other-tenant UUIDs.
   * Useful for direct lookup when the caller already has the release ID (e.g. Flyman after CI ingestion).
   */
  getRelease?: Maybe<Release>;
  /**
   * Paginated release list with optional filters.
   * Returns releases for the authenticated tenant, ordered by started_at DESC.
   */
  getReleases?: Maybe<ReleaseConnection>;
  /**
   * Distinct workflow names for the tenant, optionally filtered by repository
   * and artifact presence. Used by the UI for filter dropdowns.
   */
  searchWorkflowNames: Array<Scalars['String']['output']>;
};


/** Queries for releases */
export type FlyReleasesQueriesGetReleaseArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for releases */
export type FlyReleasesQueriesGetReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReleaseWhereInput>;
};


/** Queries for releases */
export type FlyReleasesQueriesSearchWorkflowNamesArgs = {
  hasArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
  repository?: InputMaybe<Scalars['String']['input']>;
};

/**
 * FlyWatchesQueries groups notification watch read queries, matching the
 * existing `FlyArtifactsQueries` / `FlyApmQueries` shape.
 */
export type FlyWatchesQueries = {
  __typename?: 'FlyWatchesQueries';
  /**
   * List the notification watches visible to the caller: their own
   * personal watches plus every shared (team/channel) watch. Paginated
   * so large watch lists are returned one page at a time.
   */
  searchWatches: WatchConnection;
};


/**
 * FlyWatchesQueries groups notification watch read queries, matching the
 * existing `FlyArtifactsQueries` / `FlyApmQueries` shape.
 */
export type FlyWatchesQueriesSearchWatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * IntermediateRelease represents a release that was created between two deployments
 * but was never individually deployed to the environment.
 */
export type IntermediateRelease = {
  __typename?: 'IntermediateRelease';
  /** Short summary of the release */
  shortSummary?: Maybe<Scalars['String']['output']>;
  /** When the CI workflow run started */
  timestamp: Scalars['DateTime']['output'];
  /** AI-generated release title */
  title?: Maybe<Scalars['String']['output']>;
  /** URL to the CI workflow run */
  url?: Maybe<Scalars['String']['output']>;
  /** Workflow name */
  workflowName: Scalars['String']['output'];
  /** Workflow run number */
  workflowNumber: Scalars['String']['output'];
};

/**
 * PageInfo type for Relay-style cursor-based pagination.
 * Provides navigation information for paginated results.
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Cursor pointing to the last item in the current page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more items after the current page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are more items before the current page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor pointing to the first item in the current page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** PullRequest represents a pull request/merge request */
export type PullRequest = {
  __typename?: 'PullRequest';
  /** GitHub login of the pull request author */
  author?: Maybe<Scalars['String']['output']>;
  /** Description/body of the pull request */
  description: Scalars['String']['output'];
  /** Timestamp when the pull request was merged */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Title of the pull request */
  title: Scalars['String']['output'];
  /** URL to the pull request on the VCS provider */
  url: Scalars['String']['output'];
};

/** PullRequestConnection is a paginated list of pull requests */
export type PullRequestConnection = {
  __typename?: 'PullRequestConnection';
  /** List of pull request edges */
  edges: Array<PullRequestEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of pull requests */
  totalCount: Scalars['Int']['output'];
};

/** PullRequestEdge wraps a PullRequest with its pagination cursor */
export type PullRequestEdge = {
  __typename?: 'PullRequestEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The pull request node */
  node: PullRequest;
};

/** Root Query type for the Fly GraphQL v2 API */
export type Query = {
  __typename?: 'Query';
  /** Team APM catalog (skills, APM packages, marketplace plugins) */
  flyApm: FlyApmQueries;
  /** Artifact queries */
  flyArtifacts: FlyArtifactsQueries;
  /** Decision record queries (tenant-wide, grouped by repository) */
  flyDecisionRecords: FlyDecisionRecordsQueries;
  /** Environment operations */
  flyEnvironments: FlyEnvironmentsQueries;
  /** Git repository queries */
  flyGitRepositories: FlyGitRepositoriesQueries;
  /** Operational information and registry insights */
  flyOperationalInfo: FlyOperationalInfoQueries;
  /** Release queries */
  flyReleases: FlyReleasesQueries;
  /** Notification watch queries */
  flyWatches: FlyWatchesQueries;
};

/** RegistryInsights provides high-level statistics about the Fly registry */
export type RegistryInsights = {
  __typename?: 'RegistryInsights';
  /** Total dependency download count from the registry */
  dependenciesDownloadedCount: Scalars['Int']['output'];
  /** Dependency downloads today */
  dependenciesDownloadedToday: Scalars['Int']['output'];
  /** Number of repositories that have CI configured with Fly */
  repositoriesConnected: Scalars['Int']['output'];
  /** Total number of Git repositories accessible to the installation */
  repositoriesCount: Scalars['Int']['output'];
  /** Number of repositories that are ignored by the registry */
  repositoriesIgnored: Scalars['Int']['output'];
  /** Number of users that are connected to the registry */
  usersConnected: Scalars['Int']['output'];
  /** Total number of users in the registry */
  usersCount: Scalars['Int']['output'];
};

/** Input for querying registry insights */
export type RegistryInsightsInput = {
  /** Optional installation ID filter */
  installationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A release represents a single CI/CD build that produced artifacts.
 * Used in both the top-level flyReleases namespace and the nested
 * Repository → Workflow → releases path. Includes server-side isLatest
 * computation on environments.
 */
export type Release = {
  __typename?: 'Release';
  /** Git branch the release was built from */
  branch?: Maybe<Scalars['String']['output']>;
  /** CI provider that produced this release (e.g. "github") */
  ciProvider?: Maybe<Scalars['String']['output']>;
  /** CI-specific run identifier */
  ciRunId?: Maybe<Scalars['String']['output']>;
  /** Git commit SHA of the release */
  commitSha?: Maybe<Scalars['String']['output']>;
  /**
   * Commits included in this release (embedded in the release record).
   * Pagination args are accepted for Relay spec compliance but currently ignored.
   */
  commits: CommitConnection;
  /** Decision records extracted from developer-agent conversations linked to this release. */
  decisionRecords: Array<DecisionRecord>;
  /** URL-encoded run ID */
  encodedId: Scalars['String']['output'];
  /** Environments this release is deployed to, with isLatest computed server-side */
  environments: Array<ReleaseEnvironmentStatus>;
  /** Full release summary in structured markdown. From release.full_summary build property. */
  fullSummary?: Maybe<Scalars['String']['output']>;
  /**
   * True when at least one artifact uploaded in this release is currently
   * distributable (i.e. a public-distribution flow exists for its package type).
   * Used by the FE to decide whether to render the Distribute menu on the release item.
   *
   * Phase 1: only Generic artifacts are distributable; this is true iff at least one
   * uploaded artifact has package_type = "generic". Future phases will extend the
   * set without requiring an FE rename — that's why the field is named
   * `hasDistributableArtifact` rather than `hasGenericArtifact`.
   */
  hasDistributableArtifact?: Maybe<Scalars['Boolean']['output']>;
  /** True when at least one artifact linked to this release is currently publicly distributed. */
  hasPublicArtifacts?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the release (database UUID) */
  id: Scalars['ID']['output'];
  /** Workflow name */
  name: Scalars['String']['output'];
  /** Run number (typically sequential within a workflow) */
  number: Scalars['String']['output'];
  /** Package manager types used in the build */
  packageManagers?: Maybe<Array<Scalars['String']['output']>>;
  /** Previous git commit SHA (for diff context) */
  previousCommitSha?: Maybe<Scalars['String']['output']>;
  /** Artifact versions from this release that are currently publicly distributed. */
  publicArtifacts: Array<ArtifactVersion>;
  /**
   * Pull requests included in this release (embedded in the release record).
   * Pagination args are accepted for Relay spec compliance but currently ignored.
   */
  pullRequests: PullRequestConnection;
  /** Repository name from the release's VCS repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** Repository owner (GitHub org or user) from the release's VCS repository */
  repositoryOwner?: Maybe<Scalars['String']['output']>;
  /** Short plain-text summary for hover/dashboard display. From release.short_summary build property. */
  shortSummary?: Maybe<Scalars['String']['output']>;
  /** Current status of the run (e.g., success, failure, cancelled, in_progress) */
  status: Scalars['String']['output'];
  /** Release summary (overview/reasoning). From release.summary build property. */
  summary: Scalars['String']['output'];
  /** Timestamp when the run started */
  timestamp: Scalars['DateTime']['output'];
  /** AI-generated release title with emoji categorization. From release.title build property. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Artifacts uploaded during this release (embedded in the release record).
   * Pagination args are accepted for Relay spec compliance but currently ignored.
   */
  uploadedArtifacts: ArtifactConnection;
  /** User who triggered the workflow run */
  uploadedBy?: Maybe<Scalars['String']['output']>;
  /** URL to the workflow run on the CI provider */
  url: Scalars['String']['output'];
};


/**
 * A release represents a single CI/CD build that produced artifacts.
 * Used in both the top-level flyReleases namespace and the nested
 * Repository → Workflow → releases path. Includes server-side isLatest
 * computation on environments.
 */
export type ReleaseCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A release represents a single CI/CD build that produced artifacts.
 * Used in both the top-level flyReleases namespace and the nested
 * Repository → Workflow → releases path. Includes server-side isLatest
 * computation on environments.
 */
export type ReleasePullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A release represents a single CI/CD build that produced artifacts.
 * Used in both the top-level flyReleases namespace and the nested
 * Repository → Workflow → releases path. Includes server-side isLatest
 * computation on environments.
 */
export type ReleaseUploadedArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** ReleaseConnection is a paginated list of releases */
export type ReleaseConnection = {
  __typename?: 'ReleaseConnection';
  /** List of release edges containing the nodes and cursors */
  edges: Array<ReleaseEdge>;
  /** Distinct environments across all matching releases (for filter dropdown) */
  environments: Array<ReleaseEnvironmentStatus>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Number of releases in this page (not the total across all pages) */
  totalCount: Scalars['Int']['output'];
  /** Distinct uploaders across all matching releases (for filter dropdown) */
  uploaders: Array<Scalars['String']['output']>;
};

/** ReleaseEdge wraps a Release with its pagination cursor */
export type ReleaseEdge = {
  __typename?: 'ReleaseEdge';
  /** Cursor for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The release node */
  node: Release;
};

/**
 * Deprecated: Use ReleaseEnvironmentStatus instead.
 * Lightweight environment reference attached to a workflow run (id + name only).
 * TODO: Remove once flyman migrates to Release types.
 */
export type ReleaseEnvironment = {
  __typename?: 'ReleaseEnvironment';
  /** Environment database identifier */
  id: Scalars['ID']['output'];
  /** Environment name */
  name: Scalars['String']['output'];
};

/**
 * ReleaseEnvironmentStatus extends ReleaseEnvironment with isLatest.
 * The server computes whether this release is the most recent one
 * deployed to each environment, eliminating client-side cross-referencing.
 */
export type ReleaseEnvironmentStatus = {
  __typename?: 'ReleaseEnvironmentStatus';
  /** Environment database identifier */
  id: Scalars['ID']['output'];
  /**
   * True if this release is the latest (most recently pulled) release
   * in this environment. Computed server-side via image_pulls.
   */
  isLatest: Scalars['Boolean']['output'];
  /** Environment name */
  name: Scalars['String']['output'];
};

/**
 * Filter input for release queries.
 * All fields are optional; when multiple are provided they are combined with AND logic,
 * while values within each list use OR logic.
 */
export type ReleaseWhereInput = {
  /**
   * Filter to releases belonging to a single deployment wave on a given environment.
   * The wave is computed server-side identically to DeploymentDelta — the current
   * release plus rollback-aware intermediate releases per fly-service#1122 §2.3.
   *
   * Used by the env page deployment cards: hovering a card shows the first 3 releases
   * of the wave, clicking "more" navigates to the Releases page with this filter
   * applied so the user sees ALL releases of that wave (current + intermediates),
   * even when the wave contains many more than 3.
   *
   * Combinable with other filters (search, lastRun, runIds, ...) — applied as AND.
   * Returns an empty connection if the referenced wave does not exist on the env
   * (graceful: the FE renders an empty state, no error UX needed).
   * @deprecated Use deploymentId instead — the opaque ID survives reserved characters in workflow names (& < > : / etc.) and is FE-orderable as a single URL token.
   */
  deployment?: InputMaybe<DeploymentRefInput>;
  /**
   * Opaque deployment-wave identifier (DeploymentDelta.id). Preferred over
   * `deployment` because it encodes the same triple in a single URL-safe
   * token, eliminating the special-character escaping issues that surface
   * when workflow names contain reserved URL/HTML characters
   * (fly-service#1241). When both `deployment` and `deploymentId` are
   * provided, `deploymentId` wins. Malformed / non-existent / cross-tenant
   * IDs short-circuit to an empty connection (same graceful behavior as the
   * triple path).
   */
  deploymentId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by environment IDs (OR logic) — show only releases deployed to any of these environments */
  environmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter by environment names (OR logic, case-insensitive exact match) — show only releases deployed to any of these environments.
   * Preferred over environmentIDs for programmatic clients that work with environment names.
   */
  environmentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * When true, only return releases that uploaded at least one artifact.
   * When false, only return releases with no artifacts. Omit to return all.
   */
  hasArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by run timestamp: show only releases started within the given window.
   * Supported values: "24h" (last 24 hours), "7d" (last 7 days), "14d" (last 14 days).
   */
  lastRun?: InputMaybe<Scalars['String']['input']>;
  /** Filter by VCS repository ("owner/name" format, exact match) */
  repository?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by run IDs (OR logic) — show only releases matching any of these composite IDs (e.g. workflowName/runNumber).
   * Used by the repository→workflow→runs path for filtered queries.
   */
  runIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Free-text search: show only releases whose title, workflow name, or run number matches (case-insensitive substring). */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter to releases started at or after this timestamp (inclusive). */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter to releases started at or before this timestamp (inclusive). */
  until?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by uploader user names (OR logic) — show only releases created by any of these users */
  uploaderNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by workflow name (exact match) */
  workflowName?: InputMaybe<Scalars['String']['input']>;
};

/** Repository represents a Git repository in the registry */
export type Repository = {
  __typename?: 'Repository';
  /** Paginated list of artifacts associated with this repository. */
  artifacts: ArtifactConnection;
  /** Count of artifacts associated with this repository */
  artifactsCount: Scalars['Int']['output'];
  /** Whether CI is configured for this repository */
  ciConfigured: Scalars['Boolean']['output'];
  /** Number of workflows that have JFrog Fly actions configured */
  configuredWorkflowsCount: Scalars['Int']['output'];
  /** Count of dependencies in the repository */
  dependenciesCount: Scalars['Int']['output'];
  /** URL-encoded repository name for safe URL construction */
  encodedName: Scalars['String']['output'];
  /** URL-encoded owner name for safe URL construction */
  encodedOwner: Scalars['String']['output'];
  /** Timestamp of the most recent artifact upload for this repository */
  lastUploadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** The most recently uploaded artifact version (null if repository has no artifacts) */
  latestArtifact?: Maybe<ArtifactVersion>;
  /** Count of malicious dependencies detected */
  maliciousDependenciesCount: Scalars['Int']['output'];
  /** Name of the repository */
  name: Scalars['String']['output'];
  /** Owner of the repository (organization or user) */
  owner: Scalars['String']['output'];
  /** List of package manager types used in this repository */
  packageManagers: Array<Scalars['String']['output']>;
  /** Distinct list of users who triggered releases in this tenant, for filter dropdowns */
  uploaders: Array<Scalars['String']['output']>;
  /** URL to the repository on the VCS provider */
  url: Scalars['String']['output'];
  /** Paginated list of workflows in this repository */
  workflows: WorkflowConnection;
};


/** Repository represents a Git repository in the registry */
export type RepositoryArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Repository represents a Git repository in the registry */
export type RepositoryWorkflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** RepositoryConnection is a paginated list of repositories */
export type RepositoryConnection = {
  __typename?: 'RepositoryConnection';
  /** List of repository edges containing the nodes and cursors */
  edges: Array<RepositoryEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of repositories matching the query */
  totalCount: Scalars['Int']['output'];
};

/** RepositoryEdge wraps a Repository with its pagination cursor */
export type RepositoryEdge = {
  __typename?: 'RepositoryEdge';
  /** Cursor for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The repository node */
  node: Repository;
};

/** Input for querying a specific repository */
export type RepositoryInput = {
  /** Optional installation ID filter */
  installationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the repository (required) */
  name: Scalars['String']['input'];
  /** Owner of the repository (required) */
  owner: Scalars['String']['input'];
  /** Optional workflow name filter */
  workflowName?: InputMaybe<Scalars['String']['input']>;
  /** Optional workflow run number filter (requires workflowName) */
  workflowRunNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input for searching repositories */
export type RepositoryWhereInput = {
  /** Optional installation ID filter */
  installationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional repository name pattern (supports glob wildcards) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional owner filter */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Force refresh from GitHub, bypassing cache */
  refreshCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Watch is one notification watch visible to the caller. IDs are internal
 * and intended for follow-up update/delete operations, not for display.
 */
export type Watch = {
  __typename?: 'Watch';
  /** Notification delivery targets for this watch. */
  channels: Array<WatchChannel>;
  /** Fly username of who created the watch. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** When the watch was created. */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Free-text semantic expression describing what the watch matches. */
  expression: Scalars['String']['output'];
  /** Internal watch identifier (UUID). */
  id: Scalars['ID']['output'];
  /** Slack team identifier the watch is bound to, when set. */
  slackTeamId?: Maybe<Scalars['String']['output']>;
  /** Fly username of who last updated the watch. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** When the watch was last updated. */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * WatchChannel is a single notification delivery target on a watch.
 * Mirrors the REST `dal.NotificationChannel` shape produced by
 * `dal.ChannelsFromEntries`.
 */
export type WatchChannel = {
  __typename?: 'WatchChannel';
  /** Platform-specific ID (e.g. Slack channel/user ID) when resolved. */
  id?: Maybe<Scalars['String']['output']>;
  /** Delivery platform (currently always "slack"). */
  medium: Scalars['String']['output'];
  /**
   * Target identifier. Empty for user/tenant scope; the channel name
   * (e.g. "#builds") for channel scope.
   */
  recipient?: Maybe<Scalars['String']['output']>;
  /**
   * Routing scope: "user" (DM the caller), "channel" (post to a Slack
   * channel), or "tenant" (broadcast to all Slack-linked team members).
   */
  scope: Scalars['String']['output'];
};

/**
 * WatchConnection is the connection shape returned by `searchWatches`.
 * The resolver loads the caller's full visible watch set, then pages in
 * memory using an opaque cursor (base64-encoded watch id). Clients should
 * treat the cursor as opaque.
 */
export type WatchConnection = {
  __typename?: 'WatchConnection';
  /** Watches for the current page. */
  edges: Array<WatchEdge>;
  /** Pagination information for the current page. */
  pageInfo: PageInfo;
};

/** WatchEdge wraps a watch with its pagination cursor. */
export type WatchEdge = {
  __typename?: 'WatchEdge';
  /** Cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** Watch node. */
  node: Watch;
};

/** Workflow represents a CI/CD workflow in a repository */
export type Workflow = {
  __typename?: 'Workflow';
  /** Whether CI is configured for this workflow */
  ciConfigured: Scalars['Boolean']['output'];
  /** URL-encoded workflow name */
  encodedName: Scalars['String']['output'];
  /** Unique identifier for the workflow */
  id: Scalars['String']['output'];
  /** Timestamp of the most recent download in this workflow */
  latestDownloadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the most recent upload in this workflow */
  latestUploadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Name of the workflow */
  name: Scalars['String']['output'];
  /**
   * Paginated list of releases for this workflow.
   * Use the where input to filter by environment IDs, uploader names, and/or run IDs (OR logic within each list).
   */
  releases: ReleaseConnection;
  /**
   * Deprecated: Use releases instead. Kept for backward compatibility with flyman.
   * TODO: Remove once flyman migrates to Release types.
   * @deprecated Use releases instead
   */
  runs: WorkflowRunConnection;
  /** URL to the workflow on the CI provider */
  url: Scalars['String']['output'];
};


/** Workflow represents a CI/CD workflow in a repository */
export type WorkflowReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReleaseWhereInput>;
};


/** Workflow represents a CI/CD workflow in a repository */
export type WorkflowRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkflowRunWhereInput>;
};

/** WorkflowConnection is a paginated list of workflows */
export type WorkflowConnection = {
  __typename?: 'WorkflowConnection';
  /** List of workflow edges */
  edges: Array<WorkflowEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of workflows */
  totalCount: Scalars['Int']['output'];
};

/** WorkflowEdge wraps a Workflow with its pagination cursor */
export type WorkflowEdge = {
  __typename?: 'WorkflowEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The workflow node */
  node: Workflow;
};

/**
 * Deprecated: Use Release instead.
 * WorkflowRun is kept for backward compatibility with flyman.
 * TODO: Remove once flyman migrates to Release types.
 */
export type WorkflowRun = {
  __typename?: 'WorkflowRun';
  /** Paginated list of commits included in this run */
  commits: CommitConnection;
  /** URL-encoded run ID */
  encodedId: Scalars['String']['output'];
  /** Environments this release is currently deployed to */
  environments: Array<ReleaseEnvironment>;
  /** Full release summary in structured markdown. From release.full_summary build property. */
  fullSummary?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the workflow run */
  id: Scalars['String']['output'];
  /** Name of the workflow run */
  name: Scalars['String']['output'];
  /** Run number (typically sequential within a workflow) */
  number: Scalars['String']['output'];
  /** Paginated list of pull requests included in this run */
  pullRequests: PullRequestConnection;
  /** Short plain-text summary for hover/dashboard display. From release.short_summary build property. */
  shortSummary?: Maybe<Scalars['String']['output']>;
  /** Current status of the run (e.g., success, failure, in_progress) */
  status: Scalars['String']['output'];
  /** Release summary (overview/reasoning). From release.summary build property. */
  summary: Scalars['String']['output'];
  /** Timestamp when the run started */
  timestamp: Scalars['DateTime']['output'];
  /** AI-generated release title with emoji categorization. From release.title build property. */
  title?: Maybe<Scalars['String']['output']>;
  /** Paginated list of artifacts uploaded during this run */
  uploadedArtifacts: ArtifactConnection;
  /** User who triggered the workflow run */
  uploadedBy?: Maybe<Scalars['String']['output']>;
  /** URL to the workflow run on the CI provider */
  url: Scalars['String']['output'];
};


/**
 * Deprecated: Use Release instead.
 * WorkflowRun is kept for backward compatibility with flyman.
 * TODO: Remove once flyman migrates to Release types.
 */
export type WorkflowRunCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Deprecated: Use Release instead.
 * WorkflowRun is kept for backward compatibility with flyman.
 * TODO: Remove once flyman migrates to Release types.
 */
export type WorkflowRunPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Deprecated: Use Release instead.
 * WorkflowRun is kept for backward compatibility with flyman.
 * TODO: Remove once flyman migrates to Release types.
 */
export type WorkflowRunUploadedArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Deprecated: Use ReleaseConnection instead.
 * TODO: Remove once flyman migrates to Release types.
 */
export type WorkflowRunConnection = {
  __typename?: 'WorkflowRunConnection';
  /** List of workflow run edges */
  edges: Array<WorkflowRunEdge>;
  /** Distinct list of environments across all releases in this connection */
  environments: Array<ReleaseEnvironment>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Number of workflow runs in this page (not the total across all pages) */
  totalCount: Scalars['Int']['output'];
  /** Distinct list of users who created the releases in this connection */
  uploaders: Array<Scalars['String']['output']>;
};

/**
 * Deprecated: Use ReleaseEdge instead.
 * TODO: Remove once flyman migrates to Release types.
 */
export type WorkflowRunEdge = {
  __typename?: 'WorkflowRunEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The workflow run node */
  node: WorkflowRun;
};

/**
 * Deprecated: Use ReleaseWhereInput instead.
 * Mirrors ReleaseWhereInput so the OneModel linter accepts it on WorkflowRunConnection fields.
 * TODO: Remove once flyman migrates to Release types.
 */
export type WorkflowRunWhereInput = {
  environmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
  lastRun?: InputMaybe<Scalars['String']['input']>;
  repository?: InputMaybe<Scalars['String']['input']>;
  runIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
  uploaderNames?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowName?: InputMaybe<Scalars['String']['input']>;
};

export type SearchDecisionRecordRepositoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  repositories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  repositoryNameSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchDecisionRecordRepositoriesQuery = { __typename?: 'Query', flyDecisionRecords: { __typename?: 'FlyDecisionRecordsQueries', searchDecisionRecordRepositories: Array<{ __typename?: 'DecisionRecordRepositoryCount', repository: string, count: number }> } };

export type GetDecisionRecordsByRepoQueryVariables = Exact<{
  repositories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  repositoryNameSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDecisionRecordsByRepoQuery = { __typename?: 'Query', flyDecisionRecords: { __typename?: 'FlyDecisionRecordsQueries', getDecisionRecords?: { __typename?: 'DecisionRecordConnection', edges: Array<{ __typename?: 'DecisionRecordEdge', cursor: string, node: { __typename?: 'DecisionRecord', id: string, title: string, recordType: string, description: string, createdTime: any, createdBy?: string | null, repositories: Array<string>, releaseIds: Array<string> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } };

export type GetLatestDecisionRecordsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  repositories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetLatestDecisionRecordsQuery = { __typename?: 'Query', flyDecisionRecords: { __typename?: 'FlyDecisionRecordsQueries', getDecisionRecords?: { __typename?: 'DecisionRecordConnection', edges: Array<{ __typename?: 'DecisionRecordEdge', node: { __typename?: 'DecisionRecord', id: string, title: string, createdBy?: string | null, createdTime: any } }> } | null } };

export type GetRepositoryNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRepositoryNamesQuery = { __typename?: 'Query', flyGitRepositories: { __typename?: 'FlyGitRepositoriesQueries', searchRepositories: { __typename?: 'RepositoryConnection', totalCount: number, edges: Array<{ __typename?: 'RepositoryEdge', cursor: string, node: { __typename?: 'Repository', name: string, owner: string, url: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type GetRepositoriesQueryVariables = Exact<{
  refreshCache?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  artifactsFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRepositoriesQuery = { __typename?: 'Query', flyGitRepositories: { __typename?: 'FlyGitRepositoriesQueries', searchRepositories: { __typename?: 'RepositoryConnection', totalCount: number, edges: Array<{ __typename?: 'RepositoryEdge', cursor: string, node: { __typename?: 'Repository', name: string, owner: string, url: string, artifactsCount: number, ciConfigured: boolean, configuredWorkflowsCount: number, latestArtifact?: { __typename?: 'ArtifactVersion', name: string, uploadedLocally: boolean, lastUploadTimestamp?: any | null } | null, artifacts: { __typename?: 'ArtifactConnection', edges: Array<{ __typename?: 'ArtifactEdge', node: { __typename?: 'Artifact', name: string, packageType: string, latestVersion: { __typename?: 'ArtifactVersion', name: string, lastUploadTimestamp?: any | null } } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type GetRegistryInsightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegistryInsightsQuery = { __typename?: 'Query', flyOperationalInfo: { __typename?: 'FlyOperationalInfoQueries', getRegistryInsights?: { __typename?: 'RegistryInsights', repositoriesCount: number, repositoriesConnected: number } | null } };

export type GetRepositoryArtifactsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  releasesFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRepositoryArtifactsQuery = { __typename?: 'Query', flyGitRepositories: { __typename?: 'FlyGitRepositoriesQueries', getRepository?: { __typename?: 'Repository', name: string, owner: string, url: string, packageManagers: Array<string>, artifacts: { __typename?: 'ArtifactConnection', edges: Array<{ __typename?: 'ArtifactEdge', node: { __typename?: 'Artifact', name: string, packageType: string, versionsCount: number, hasPublicDistributedArtifact?: boolean | null, latestVersion: { __typename?: 'ArtifactVersion', name: string, uploadedBy: string, lastUploadTimestamp?: any | null, uploadedLocally: boolean, releases: { __typename?: 'ReleaseConnection', edges: Array<{ __typename?: 'ReleaseEdge', node: { __typename?: 'Release', name: string, number: string } }> } } } }> } } | null } };

export type GetRepositoryWorkflowsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRepositoryWorkflowsQuery = { __typename?: 'Query', flyGitRepositories: { __typename?: 'FlyGitRepositoriesQueries', getRepository?: { __typename?: 'Repository', name: string, owner: string, url: string, workflows: { __typename?: 'WorkflowConnection', edges: Array<{ __typename?: 'WorkflowEdge', node: { __typename?: 'Workflow', id: string, name: string, url: string, ciConfigured: boolean, latestDownloadTimestamp?: any | null, latestUploadTimestamp?: any | null } }> } } | null } };

export type GetRepositoryReleaseQueryVariables = Exact<{
  name: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  workflowName: Scalars['String']['input'];
  workflowRunNumber: Scalars['String']['input'];
}>;


export type GetRepositoryReleaseQuery = { __typename?: 'Query', flyGitRepositories: { __typename?: 'FlyGitRepositoriesQueries', getRepository?: { __typename?: 'Repository', workflows: { __typename?: 'WorkflowConnection', edges: Array<{ __typename?: 'WorkflowEdge', node: { __typename?: 'Workflow', id: string, name: string, url: string, releases: { __typename?: 'ReleaseConnection', edges: Array<{ __typename?: 'ReleaseEdge', node: { __typename?: 'Release', id: string, name: string, number: string, url: string, summary: string, title?: string | null, shortSummary?: string | null, fullSummary?: string | null, status: string, timestamp: any, uploadedBy?: string | null, hasPublicArtifacts?: boolean | null, decisionRecords: Array<{ __typename?: 'DecisionRecord', id: string, title: string, recordType: string, description: string, createdTime: any, createdBy?: string | null }>, pullRequests: { __typename?: 'PullRequestConnection', edges: Array<{ __typename?: 'PullRequestEdge', node: { __typename?: 'PullRequest', title: string, url: string, description: string, timestamp?: any | null, author?: string | null } }> }, commits: { __typename?: 'CommitConnection', edges: Array<{ __typename?: 'CommitEdge', node: { __typename?: 'Commit', sha: string, message: string, url: string, body: string, timestamp?: any | null, author?: string | null } }> }, environments: Array<{ __typename?: 'ReleaseEnvironmentStatus', id: string, name: string, isLatest: boolean }>, uploadedArtifacts: { __typename?: 'ArtifactConnection', edges: Array<{ __typename?: 'ArtifactEdge', node: { __typename?: 'Artifact', name: string, packageType: string, versionsCount: number, versions: { __typename?: 'ArtifactVersionConnection', edges: Array<{ __typename?: 'ArtifactVersionEdge', node: { __typename?: 'ArtifactVersion', name: string, lastUploadTimestamp?: any | null, uploadedBy: string, uploadedLocally: boolean, url?: string | null, distribution?: { __typename?: 'DistributionSummary', distributedTime?: any | null, distributedBy?: string | null, downloadCount: number, distributionUrl?: string | null } | null } }> } } }> } } }> } } }> } } | null } };

export type GetAllArtifactsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  packageTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  repositoryOwner?: InputMaybe<Scalars['String']['input']>;
  repositoryName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllArtifactsQuery = { __typename?: 'Query', flyArtifacts: { __typename?: 'FlyArtifactsQueries', searchArtifacts: { __typename?: 'ArtifactConnection', edges: Array<{ __typename?: 'ArtifactEdge', node: { __typename?: 'Artifact', name: string, packageType: string, lastUploadTimestamp?: any | null, versionsCount: number, hasPublicDistributedArtifact?: boolean | null, latestVersion: { __typename?: 'ArtifactVersion', uploadedBy: string, uploadedLocally: boolean, name: string, releases: { __typename?: 'ReleaseConnection', edges: Array<{ __typename?: 'ReleaseEdge', node: { __typename?: 'Release', name: string, number: string } }> } }, repository?: { __typename?: 'ArtifactRepository', name: string, owner: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type GetArtifactDetailsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  versionsFirst?: InputMaybe<Scalars['Int']['input']>;
  versionsAfter?: InputMaybe<Scalars['String']['input']>;
  versionsSearch?: InputMaybe<Scalars['String']['input']>;
  releasesFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetArtifactDetailsQuery = { __typename?: 'Query', flyArtifacts: { __typename?: 'FlyArtifactsQueries', searchArtifacts: { __typename?: 'ArtifactConnection', edges: Array<{ __typename?: 'ArtifactEdge', node: { __typename?: 'Artifact', packageType: string, name: string, versions: { __typename?: 'ArtifactVersionConnection', edges: Array<{ __typename?: 'ArtifactVersionEdge', node: { __typename?: 'ArtifactVersion', name: string, lastUploadTimestamp?: any | null, uploadedBy: string, uploadedLocally: boolean, tags: Array<string>, url?: string | null, distribution?: { __typename?: 'DistributionSummary', distributedTime?: any | null, distributedBy?: string | null, downloadCount: number, distributionUrl?: string | null } | null, releases: { __typename?: 'ReleaseConnection', edges: Array<{ __typename?: 'ReleaseEdge', node: { __typename?: 'Release', name: string, number: string, url: string } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } }> } } };

export type GetArtifactFilesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  packageVersion: Scalars['String']['input'];
  packageType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArtifactFilesQuery = { __typename?: 'Query', flyArtifacts: { __typename?: 'FlyArtifactsQueries', searchDistributedFiles: { __typename?: 'DistributedFileConnection', totalCount: number, edges: Array<{ __typename?: 'DistributedFileEdge', node: { __typename?: 'DistributedFile', fileName: string, sha256?: string | null, downloadCount: number, isPublic: boolean, url?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type GetRepositoryReleasesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  repository: Scalars['String']['input'];
  workflowName?: InputMaybe<Scalars['String']['input']>;
  environmentIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  uploaderNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  lastRun?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
  runIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  deployment?: InputMaybe<DeploymentRefInput>;
  deploymentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetRepositoryReleasesQuery = { __typename?: 'Query', flyReleases: { __typename?: 'FlyReleasesQueries', getReleases?: { __typename?: 'ReleaseConnection', totalCount: number, uploaders: Array<string>, environments: Array<{ __typename?: 'ReleaseEnvironmentStatus', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'ReleaseEdge', cursor: string, node: { __typename?: 'Release', id: string, name: string, number: string, url: string, timestamp: any, status: string, uploadedBy?: string | null, title?: string | null, shortSummary?: string | null, summary: string, hasPublicArtifacts?: boolean | null, environments: Array<{ __typename?: 'ReleaseEnvironmentStatus', id: string, name: string, isLatest: boolean }>, publicArtifacts: Array<{ __typename?: 'ArtifactVersion', distribution?: { __typename?: 'DistributionSummary', downloadCount: number } | null }> } }> } | null } };

export type GetWorkflowNamesQueryVariables = Exact<{
  repository: Scalars['String']['input'];
  hasArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWorkflowNamesQuery = { __typename?: 'Query', flyReleases: { __typename?: 'FlyReleasesQueries', searchWorkflowNames: Array<string> } };

export type GetFlyEnvironmentsQueryVariables = Exact<{
  names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFlyEnvironmentsQuery = { __typename?: 'Query', flyEnvironments: { __typename?: 'FlyEnvironmentsQueries', searchEnvironments: { __typename?: 'EnvironmentConnection', edges: Array<{ __typename?: 'EnvironmentEdge', cursor: string, node: { __typename?: 'Environment', id: string, name: string, description?: string | null, color?: string | null, tokenCount: number, releaseCount: number, deploymentCount: number, deploymentDeltas: Array<{ __typename?: 'DeploymentDelta', id: string, workflowName: string, repositoryOwner?: string | null, repositoryName?: string | null, totalCommitCount: number, totalPullRequestCount: number, releaseCount: number, deployType: DeployType, daysSinceLastDeploy?: number | null, cumulativeSummary?: string | null, cumulativeTitle?: string | null, cumulativeShortSummary?: string | null, isLatestOnEnvironment: boolean, currentDeployment: { __typename?: 'EnvironmentRelease', name: string, number: string, environmentName: string, lastPulled: any, imageCount: number, summary?: string | null, shortSummary?: string | null, title?: string | null, uploadedBy?: string | null, url?: string | null, repositoryOwner?: string | null, repositoryName?: string | null, isLocal: boolean, commitCount: number, pullRequestCount: number, images: Array<{ __typename?: 'EnvironmentImage', name: string, pulled: any }> }, previousDeployment?: { __typename?: 'EnvironmentRelease', name: string, number: string, environmentName: string, lastPulled: any, imageCount: number, summary?: string | null, shortSummary?: string | null, title?: string | null, uploadedBy?: string | null, url?: string | null, repositoryOwner?: string | null, repositoryName?: string | null, isLocal: boolean, commitCount: number, pullRequestCount: number, images: Array<{ __typename?: 'EnvironmentImage', name: string, pulled: any }> } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } } };

export type GetEnvironmentDeploymentsQueryVariables = Exact<{
  environmentName: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEnvironmentDeploymentsQuery = { __typename?: 'Query', flyEnvironments: { __typename?: 'FlyEnvironmentsQueries', searchEnvironmentDeployments: { __typename?: 'DeploymentDeltaConnection', edges: Array<{ __typename?: 'DeploymentDeltaEdge', cursor: string, node: { __typename?: 'DeploymentDelta', id: string, workflowName: string, repositoryOwner?: string | null, repositoryName?: string | null, totalCommitCount: number, totalPullRequestCount: number, releaseCount: number, deployType: DeployType, daysSinceLastDeploy?: number | null, cumulativeSummary?: string | null, cumulativeTitle?: string | null, cumulativeShortSummary?: string | null, isLatestOnEnvironment: boolean, currentDeployment: { __typename?: 'EnvironmentRelease', name: string, number: string, environmentName: string, lastPulled: any, imageCount: number, summary?: string | null, shortSummary?: string | null, title?: string | null, uploadedBy?: string | null, url?: string | null, repositoryOwner?: string | null, repositoryName?: string | null, isLocal: boolean, commitCount: number, pullRequestCount: number, images: Array<{ __typename?: 'EnvironmentImage', name: string, pulled: any }> }, previousDeployment?: { __typename?: 'EnvironmentRelease', name: string, number: string, environmentName: string, lastPulled: any, imageCount: number, summary?: string | null, shortSummary?: string | null, title?: string | null, uploadedBy?: string | null, url?: string | null, repositoryOwner?: string | null, repositoryName?: string | null, isLocal: boolean, commitCount: number, pullRequestCount: number, images: Array<{ __typename?: 'EnvironmentImage', name: string, pulled: any }> } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } } };


export const SearchDecisionRecordRepositoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchDecisionRecordRepositories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repositories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repositoryNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyDecisionRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchDecisionRecordRepositories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"repositories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repositories"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"repositoryNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repositoryNameSearch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repository"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<SearchDecisionRecordRepositoriesQuery, SearchDecisionRecordRepositoriesQueryVariables>;
export const GetDecisionRecordsByRepoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDecisionRecordsByRepo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repositories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repositoryNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyDecisionRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDecisionRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"repositories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repositories"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"repositoryNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repositoryNameSearch"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"repositories"}},{"kind":"Field","name":{"kind":"Name","value":"releaseIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDecisionRecordsByRepoQuery, GetDecisionRecordsByRepoQueryVariables>;
export const GetLatestDecisionRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestDecisionRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repositories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyDecisionRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDecisionRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"repositories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repositories"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdTime"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestDecisionRecordsQuery, GetLatestDecisionRecordsQueryVariables>;
export const GetRepositoryNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRepositoryNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyGitRepositories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchRepositories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetRepositoryNamesQuery, GetRepositoryNamesQueryVariables>;
export const GetRepositoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRepositories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshCache"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifactsFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyGitRepositories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchRepositories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"refreshCache"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshCache"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"artifactsCount"}},{"kind":"Field","name":{"kind":"Name","value":"ciConfigured"}},{"kind":"Field","name":{"kind":"Name","value":"configuredWorkflowsCount"}},{"kind":"Field","name":{"kind":"Name","value":"latestArtifact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedLocally"}},{"kind":"Field","name":{"kind":"Name","value":"lastUploadTimestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifactsFirst"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packageType"}},{"kind":"Field","name":{"kind":"Name","value":"latestVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastUploadTimestamp"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetRepositoriesQuery, GetRepositoriesQueryVariables>;
export const GetRegistryInsightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRegistryInsights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyOperationalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRegistryInsights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repositoriesCount"}},{"kind":"Field","name":{"kind":"Name","value":"repositoriesConnected"}}]}}]}}]}}]} as unknown as DocumentNode<GetRegistryInsightsQuery, GetRegistryInsightsQueryVariables>;
export const GetRepositoryArtifactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRepositoryArtifacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releasesFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyGitRepositories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRepository"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"packageManagers"}},{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packageType"}},{"kind":"Field","name":{"kind":"Name","value":"versionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasPublicDistributedArtifact"}},{"kind":"Field","name":{"kind":"Name","value":"latestVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastUploadTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedLocally"}},{"kind":"Field","name":{"kind":"Name","value":"releases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releasesFirst"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRepositoryArtifactsQuery, GetRepositoryArtifactsQueryVariables>;
export const GetRepositoryWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRepositoryWorkflows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyGitRepositories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRepository"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"workflows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"ciConfigured"}},{"kind":"Field","name":{"kind":"Name","value":"latestDownloadTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"latestUploadTimestamp"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRepositoryWorkflowsQuery, GetRepositoryWorkflowsQueryVariables>;
export const GetRepositoryReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRepositoryRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowRunNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyGitRepositories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRepository"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflowName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflowRunNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowRunNumber"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"releases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"fullSummary"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"hasPublicArtifacts"}},{"kind":"Field","name":{"kind":"Name","value":"decisionRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pullRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"author"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sha"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"author"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"environments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLatest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploadedArtifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packageType"}},{"kind":"Field","name":{"kind":"Name","value":"versionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastUploadTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedLocally"}},{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributedTime"}},{"kind":"Field","name":{"kind":"Name","value":"distributedBy"}},{"kind":"Field","name":{"kind":"Name","value":"downloadCount"}},{"kind":"Field","name":{"kind":"Name","value":"distributionUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRepositoryReleaseQuery, GetRepositoryReleaseQueryVariables>;
export const GetAllArtifactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllArtifacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageTypes"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"names"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repositoryOwner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repositoryName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyArtifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchArtifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"packageTypeIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageTypes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"names"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"repositoryOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repositoryOwner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"repositoryName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repositoryName"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"packageType"}},{"kind":"Field","name":{"kind":"Name","value":"lastUploadTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"versionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasPublicDistributedArtifact"}},{"kind":"Field","name":{"kind":"Name","value":"latestVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedLocally"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"repository"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllArtifactsQuery, GetAllArtifactsQueryVariables>;
export const GetArtifactDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArtifactDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionsFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionsAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionsSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releasesFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyArtifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchArtifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"packageTypeIn"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"packageType"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionsFirst"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionsAfter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionsSearch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastUploadTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedLocally"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributedTime"}},{"kind":"Field","name":{"kind":"Name","value":"distributedBy"}},{"kind":"Field","name":{"kind":"Name","value":"downloadCount"}},{"kind":"Field","name":{"kind":"Name","value":"distributionUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"releases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releasesFirst"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetArtifactDetailsQuery, GetArtifactDetailsQueryVariables>;
export const GetArtifactFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArtifactFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyArtifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchDistributedFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"packageName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"packageVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageVersion"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"packageType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageType"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"downloadCount"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetArtifactFilesQuery, GetArtifactFilesQueryVariables>;
export const GetRepositoryReleasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRepositoryReleases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repository"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentIDs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploaderNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastRun"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"until"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"runIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deployment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeploymentRefInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReleases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"repository"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repository"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflowName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasArtifacts"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"environmentIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentIDs"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uploaderNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploaderNames"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastRun"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastRun"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"since"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"until"},"value":{"kind":"Variable","name":{"kind":"Name","value":"until"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"runIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"runIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deployment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deployment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deploymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"uploaders"}},{"kind":"Field","name":{"kind":"Name","value":"environments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"hasPublicArtifacts"}},{"kind":"Field","name":{"kind":"Name","value":"environments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLatest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicArtifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRepositoryReleasesQuery, GetRepositoryReleasesQueryVariables>;
export const GetWorkflowNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflowNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repository"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasArtifacts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchWorkflowNames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"repository"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repository"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasArtifacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasArtifacts"}}}]}]}}]}}]} as unknown as DocumentNode<GetWorkflowNamesQuery, GetWorkflowNamesQueryVariables>;
export const GetFlyEnvironmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlyEnvironments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"names"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchEnvironments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"names"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"tokenCount"}},{"kind":"Field","name":{"kind":"Name","value":"releaseCount"}},{"kind":"Field","name":{"kind":"Name","value":"deploymentCount"}},{"kind":"Field","name":{"kind":"Name","value":"deploymentDeltas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workflowName"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryOwner"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryName"}},{"kind":"Field","name":{"kind":"Name","value":"currentDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"lastPulled"}},{"kind":"Field","name":{"kind":"Name","value":"imageCount"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"shortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryOwner"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryName"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"commitCount"}},{"kind":"Field","name":{"kind":"Name","value":"pullRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pulled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"lastPulled"}},{"kind":"Field","name":{"kind":"Name","value":"imageCount"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"shortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryOwner"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryName"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"commitCount"}},{"kind":"Field","name":{"kind":"Name","value":"pullRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pulled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCommitCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPullRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"releaseCount"}},{"kind":"Field","name":{"kind":"Name","value":"deployType"}},{"kind":"Field","name":{"kind":"Name","value":"daysSinceLastDeploy"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeShortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"isLatestOnEnvironment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFlyEnvironmentsQuery, GetFlyEnvironmentsQueryVariables>;
export const GetEnvironmentDeploymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnvironmentDeployments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"environmentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flyEnvironments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchEnvironmentDeployments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"environmentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"environmentName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workflowName"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryOwner"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryName"}},{"kind":"Field","name":{"kind":"Name","value":"currentDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"lastPulled"}},{"kind":"Field","name":{"kind":"Name","value":"imageCount"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"shortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryOwner"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryName"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"commitCount"}},{"kind":"Field","name":{"kind":"Name","value":"pullRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pulled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"lastPulled"}},{"kind":"Field","name":{"kind":"Name","value":"imageCount"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"shortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryOwner"}},{"kind":"Field","name":{"kind":"Name","value":"repositoryName"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"commitCount"}},{"kind":"Field","name":{"kind":"Name","value":"pullRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pulled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCommitCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPullRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"releaseCount"}},{"kind":"Field","name":{"kind":"Name","value":"deployType"}},{"kind":"Field","name":{"kind":"Name","value":"daysSinceLastDeploy"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeShortSummary"}},{"kind":"Field","name":{"kind":"Name","value":"isLatestOnEnvironment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEnvironmentDeploymentsQuery, GetEnvironmentDeploymentsQueryVariables>;